<template>
    <div>
        <div class="container-fluid text-white" style="background: #061429;">
            <div class="container text-center">
                <div class="row justify-content-end">
                    <div class="col-lg-12 col-md-6">
                        <div class="d-flex align-items-center justify-content-center" style="height: 75px;">
                            <div style="text-align: center;">
                                <img style="vertical-align:middle;height: 50px;" src="https://b2b.novaemm.com/img/vue-logo.png" class="img-fluid">
                                <span style="vertical-align:middle">NovaEMM</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><br>
    <!--<div>
        <div style="text-align: center;margin-top: 20px;">
            <img style="vertical-align:middle;height: 50px;" src="https://b2b.novaemm.com/img/vue-logo.png" class="img-fluid">
            <span style="vertical-align:middle">NovaEMM</span>
        </div>
    </div>-->
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
        currentRoute: this.$route.name,
    }
  }
}
</script>